import type { GetCompanyResponse } from "../company";

export enum ServiceStatus {
  open = "open",
  finished = "finished",
  none = "none",
}

export enum TemplateType {
  receivables = "Receivables",
}

export enum PeriodInDays {
  one = "1",
  zero = "0",
  seven = "7",
  thirty = "30",
  ninety = "90",
  custom = "custom",
}

export type AmountReceivedResponse = {
  amount: number;
  /** Parcelas pagas no período. Só vem no valor recebido. */
  paid_count?: number | null;
};

export type AmountFeesResponse = {
  amount: number;
};

export type AmountFeesDiscountResponse = {
  amount: number;
};

export type GetChartDataProps = {
  templateType: TemplateType;
  periodInDays: PeriodInDays;
  receivableMessageRangeId: string | undefined;
  company: GetCompanyResponse | undefined;
  startAt?: Date | null;
  endAt?: Date | null;
};

export type AmountReceivedRequest = GetChartDataProps;

export type AmountFeesRequest = GetChartDataProps;

export type AmountFeesDiscountRequest = GetChartDataProps;

export type TotalMessagesSentRequest = GetChartDataProps;

export type BillConversionRequest = GetChartDataProps;

export type TotalMessagesSentResponse = AmountReceivedResponse;

export type BillConversionResponse = TotalMessagesSentResponse;
